export default [
  {
    path: '/system/account',
    name: 'AccountManage',
    component: resolve => require(['@/views/AccountManage'], resolve),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  // 新增-编辑
  {
    path: '/system/modify-form',
    name: 'AccountEC',
    component: resolve => require(['@/views/AccountManage/Form/Form'], resolve)
  }
]
